import { Clock3 } from "lucide-react";
import { slug } from "../lib/format";
import { scrollToHeading } from "../lib/useActiveHeading";
import { TracingBeam } from "./TracingBeam";

export function ReaderToc({ variant, eyebrow, headings, activeHeading, readTime, iconSize }: {
  variant: "library" | "public";
  eyebrow: string;
  headings: string[];
  activeHeading: string;
  readTime: number;
  iconSize?: number;
}) {
  const className = variant === "public" ? "public-toc" : "toc";
  return <aside className={className}>
    <span className="eyebrow">{eyebrow}</span>
    <TracingBeam headingIds={headings.map(slug)}><nav>{headings.map((heading, index) => {
      const id = slug(heading);
      const active = id === activeHeading;
      return <a
        key={`${index}-${heading}`}
        className={active ? "active" : ""}
        aria-current={active ? "true" : undefined}
        href={`#${id}`}
        onClick={(event) => { event.preventDefault(); scrollToHeading(id); }}
      ><span>{String(index + 1).padStart(2, "0")}</span>{heading}</a>;
    })}</nav></TracingBeam>
    <div className="read-time">
      <Clock3 size={iconSize} />
      <span><b>{readTime} минут</b><small>спокойного чтения</small></span>
    </div>
  </aside>;
}
